// extracted by mini-css-extract-plugin
export default {"offersSwiperContainer":"offersSwiperContainer__S93Hj"};